<template>
<div class="chapter">
<div class="inner_page">
<div id="Epigraph.html" xml:lang="en-US">
<div class="Story-5">
<p class="epigraph">Healing is a matter of time,<br/>but it is sometimes also a matter of opportunity.</p>
<p class="citation">~Hippocrates</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Epigraph.vue?86f19eba